import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { accountsRouting } from './accounts.routing';
import { SharedModule } from '../shared/shared.module';
import { UserService, AuthService, AccountsService } from '../shared/services';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import {
    MaterialFormsModule,
    MaterialUserInterfaceModule,
} from 'ng2-material-components/ng2-material-components';

import { AccountsComponent } from './accounts.component';
import { ChooseAccountComponent } from './choose-account';
import { LoginComponent } from './login';
import { AddAccountComponent } from './add-account';
import { DeleteAccountComponent } from './delete-account';

@NgModule({
    imports: [
        CommonModule,
        MaterialFormsModule,
        MaterialUserInterfaceModule,
        accountsRouting,
        SharedModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        AccountsComponent,
        ChooseAccountComponent,
        LoginComponent,
        AddAccountComponent,
        DeleteAccountComponent
    ],
    declarations: [
        AccountsComponent,
        ChooseAccountComponent,
        LoginComponent,
        AddAccountComponent,
        DeleteAccountComponent
    ],
    providers: [
        UserService,
        AuthService,
        AccountsService
    ],
})
export class AccountsModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounts/accounts.module.ts